var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"banner__container"},_vm._l((_vm.visibleBanners),function(banner,index){return _c(_vm.bannerComponent,_vm._b({key:index,tag:"component",staticClass:"banner",on:{"click":_vm.onClick}},'component',banner,false))}),1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6d2f2c88","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/modules/shared/banners/SimpleBannerContainer.vue
// module id = 2038
// module chunks = 0